import React from 'react';
export default function Footer() {
  return (
    <div className="footer--container">
      <h3 className="footer--content">&copy; Trip-To-Utopia 2022</h3>
    </div>
  );
}
